export default {"src":"/org/_next/static/media/cancellation.cf9bf988.svg","height":14,"width":12,"blurWidth":0,"blurHeight":0};